import { LitElement, css, html } from 'lit'
import { customElement, property, state } from 'lit/decorators.js'
import { debounce } from 'lodash'

const INITIAL_DELAY = 2000;

@customElement('ep-session-disclaimer')
export class EPSessionDisclaimer extends LitElement {

  @property({ type: String, reflect: true })
  key: string = 'default';

  @property({ type: Boolean, attribute: 'must-scroll-to-bottom', reflect: true })
  mustScrollToBottom: boolean = false;
  
  @property({ type: Boolean, attribute: 'allow-denial', reflect: true })
  allowDenial: boolean = false;

  @property({ attribute: false })
  hasScrolledToBottom: boolean = false;

  @property({ attribute: false })
  initialDelayHasPassed: boolean = false;

  get allowAccepting(): boolean {
    return this.mustScrollToBottom ? (this.hasScrolledToBottom && this.initialDelayHasPassed) : this.initialDelayHasPassed;
  }

  get denyCapable(): boolean {
    return history.length > 1;// && document.referrer !== '';
  }

  get accepted(): boolean {
    return sessionStorage.getItem(`ep-session-disclaimer.${this.key}`) === 'true';
  }
  set accepted(value: boolean) {
    sessionStorage.setItem(`ep-session-disclaimer.${this.key}`, `${value}`);
    this.requestUpdate();
  }

  private _handleAccept() {
    this.accepted = true;
  }

  private _handleDeny() {
    this.accepted = false;
    if (this.denyCapable) {
      window.history.back();
    }
  }

  @state()
  scrollingDiv?: HTMLElement;

  private _handleScroll = debounce(() => {
    const IS_SCROLLED_TO_BOTTOM = (
      this.scrollingDiv !== undefined
      && Math.ceil(this.scrollingDiv.scrollHeight - this.scrollingDiv.scrollTop) === this.scrollingDiv.clientHeight
    );
    // set it to true once and leave it alone
    this.hasScrolledToBottom = this.hasScrolledToBottom || IS_SCROLLED_TO_BOTTOM;
  }, 250, { leading: false, trailing: true })

  private _handleSlotChange(event: Event) {
    if (event.target instanceof HTMLElement) {
      // we need to save a copy
      const target = event.target;
      // let the rest of the page to load or something
      setTimeout(() => {
        // specifically chosen for <fluent-dialog>, might break in the future
        const scrollingDiv = target.parentElement?.assignedSlot?.parentElement;
        //console.log('scrollingDiv', scrollingDiv)
        if (scrollingDiv instanceof HTMLElement) {
          this.scrollingDiv = scrollingDiv;
          scrollingDiv.removeEventListener('scroll', this._handleScroll);
          scrollingDiv.addEventListener('scroll', this._handleScroll)
          this._handleScroll();
        }
      }, 250);
    }
  }

  protected firstUpdated() {
    setTimeout(() => {
      this.initialDelayHasPassed = true;
    }, INITIAL_DELAY);
  }

  render() {
    return html`
      <ep-fluent-dialog modal trap-focus .isOpen=${!this.accepted} hide-close-button deny-dismissing show-actions>
        <slot name="frame-title" slot="frame-title">
          <h3>
            Test Title
          </h3>
        </slot>
        <div style="padding: 5px 1rem;">
          <slot @slotchange=${this._handleSlotChange}></slot>
        </div>
        <ep-contents slot="frame-actions">
          <div style="flex: 1;"></div>
          <fluent-button appearance="accent" @click=${this._handleAccept} .disabled=${!this.allowAccepting}>
            <slot name="accept-verbiage">Accept</slot>
          </fluent-button>
          ${
            this.allowDenial && this.denyCapable
            ? html`
            <fluent-button appearance="neutral" @click=${this._handleDeny}>
              <slot name="deny-verbiage">Deny</slot>
            </fluent-button>
            `
            : ''
          }
        </ep-contents>
      </ep-fluent-dialog>
    `
  }

  static styles = css`
    :host {
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-session-disclaimer': EPSessionDisclaimer
  }
}
